import React from 'react';

import PropTypes from 'prop-types';

import uuidv4 from 'uuid';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { Tooltip, Fade } from '@material-ui/core';

//component:
// import FloatNumberFormatInput from '../float_number_input_formatter';
import IntNumberFormatInput from '../int_number_input_formatter';
import { Typography } from '@material-ui/core';


const drawerWidth = 240;

const styles = theme => ({
    root: {
        height: '100%',
        width: drawerWidth
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    button: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    span: {
        minHeight: 70
    },
    inputRight: {
        textAlign: 'right'
    },
    title: {
        color: theme.palette.secondary.main
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },

});

class EditLectArcade extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            id: this.props.lectura.id ? this.props.lectura.id : uuidv4(),
            contadorIni: this.props.lectura.contadorIni ? this.props.lectura.contadorIni : 0,
            contadorFin: this.props.lectura.contadorFin ? this.props.lectura.contadorFin : 0,
            ingresos: this.props.lectura.ingresos ? this.props.lectura.ingresos : 0,
            comentario: this.props.lectura.comentario ? this.props.lectura.comentario : '',
            regInterno: this.props.lectura.regInterno ? this.props.lectura.regInterno : ''
        };
    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    renderIngresos = () => {

        // const { classes } = this.props;

        // if (this.props.lectura.iTipo === 2) return (<div></div>);
        // return (
        //     <FormControl className={classes.formControl}>
        //         <TextField
        //             id={'ingresos'}
        //             label={'Ingresos'}
        //             placeholder={'Ingresos'}
        //             className={classes.textField}
        //             margin="normal"
        //             value={this.state.ingresos}
        //             InputProps={{ classes: { input: classes.inputRight }, inputComponent: FloatNumberFormatInput }}
        //             onChange={(event) => this.handleValueChange(event, 'ingresos')}
        //         />
        //     </FormControl>
        // );
    };

    render() {
        const { classes } = this.props;

        return (

            <form className={classes.root} autoComplete="off">

                <div>
                    <Typography className={classes.title} variant='h4'>{this.props.maquina}</Typography>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'regInterno'}
                            label={'Registro interno'}
                            placeholder={'Registro interno'}
                            className={classes.textField}
                            margin="normal"
                            defaultValue={this.state.regInterno}
                            InputProps={{ classes: { input: classes.inputRight } }}
                            disabled
                        />
                    </FormControl>

                    <Tooltip title="Valor inicial del contador" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{tooltip: this.props.classes.tooltip}}>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'contadorIni'}
                                label={'Contador Ini'}
                                placeholder={'Contador Ini'}
                                className={classes.textField}
                                margin="normal"
                                defaultValue={this.state.contadorIni}
                                InputProps={{ classes: { input: classes.inputRight }, inputComponent: IntNumberFormatInput }}
                                disabled
                            />
                        </FormControl>
                    </Tooltip>

                    <Tooltip title="Valor del contador en esta fecha" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{tooltip: this.props.classes.tooltip}}>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'contadorFin'}
                                label={'Contador Fin'}
                                placeholder={'Contador Fin'}
                                className={classes.textField}
                                margin="normal"
                                value={this.state.contadorFin}
                                InputProps={{ classes: { input: classes.inputRight }, inputComponent: IntNumberFormatInput }}
                                onChange={(event) => this.handleValueChange(event, 'contadorFin')}
                            />
                        </FormControl>
                    </Tooltip>

                    <Tooltip title="Comentario" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{tooltip: this.props.classes.tooltip}}>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'comentario'}
                                label={'Comentario'}
                                placeholder={'Comentario'}
                                className={classes.textField}
                                margin="normal"
                                value={this.state.comentario}
                                onChange={(event) => this.handleValueChange(event, 'comentario')}
                            />
                        </FormControl>
                    </Tooltip>

                    {this.renderIngresos()}

                    <div className={classes.span}></div>

                </div>
                <div>
                    <Button variant="contained" color="secondary" className={classes.button} onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button variant="contained" color="primary" className={classes.button} onClick={() => {
                        const lectura = {
                            ...this.props.lectura,
                            contadorFin: this.state.contadorFin,
                            comentario: this.state.comentario,
                            ingresos: this.state.ingresos
                        }

                        if (!this.props.checkValues(lectura)) {
                            window.alert("ERROR");
                        }
                        else {

                            this.props.okHandler(lectura);
                            this.props.hideDialog();
                        }
                    }
                    }>OK</Button>
                </div>

            </form>
        );

    };


};

EditLectArcade.propTypes = {
    lectura: PropTypes.object,
    maquina: PropTypes.string.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkValues: PropTypes.func.isRequired,
    usuario: PropTypes.number.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditLectArcade);